/* eslint-disable */
import { Theme, createStyles, makeStyles } from "@material-ui/core";

export const styles = (theme: Theme) =>
  createStyles({
    card: {
      maxWidth: theme.spacing(55.9),
      width: "100%",
      height: 72,
      minWidth: theme.spacing(16),
      border: "1px solid rgba(0, 0, 0, 0.05)",
      borderRadius: 6,
      boxShadow: "inherit",
      "&:hover": {
        boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
      },
      background: "#FBFBFB",
    },
    actionArea: {
      position: "relative",
      height: "inherit",
      display: "flex",
      justifyContent: "flex-end",
      background: "#FBFBFB",
    },
    content: {
      width: "100%",
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
      padding: "0 20px 0 0",
    },
    image: {
      boxShadow: "0 0 3px 1px #cdcdcd",
      width: "100%",
      maxWidth: theme.spacing(30.5),
      height: "inherit",
      maxHeight: theme.spacing(24),
    },
    imageBox: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      background: "#004A96",
      margin: "20px 16px 20px 20px",
      borderRadius: 3,
      width: 41,
      height: 32,
      "& svg": {
        width: 24,
        height: 24,
      },
    },
    title: {
      fontSize: "14px",
      lineHeight: "20px",
      textOverflow: "ellipsis",
      overflow: "hidden",
      whiteSpace: "nowrap",
      color: "#333333",
      fontWeight: "bold",
    },
    date: {
      fontSize: "12px",
      lineHeight: "20px",
      color: "#333333",
      opacity: 0.5,
    },
  });

export const useStyles = makeStyles(styles);
